import React, { Component } from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { connect } from 'react-redux';
import cx from 'classnames';
import {
    Grid,
    Row,
    Col
} from 'react-bootstrap';
import s from './GetStarted.css';
import cs from '../../commonStyle.css';
import getStartedImage from '/images/whyhost/getStarted.png';

// Translation
import { FormattedMessage } from 'react-intl';
import messages from '../../../locale/messages';

class GetStarted extends Component {
    render() {
        const { data } = this.props;

        return (
            <div className={s.getStartedSection}>
                <div className={s.container}>
                    <div className={cs.textAlignCenter}>
                        <h2 className={s.getStartedTitle}>How To Get Started</h2>
                    </div>
                    <Row className={cx(cs.dFlex, s.flexWrap)}>
                        <Col lg={5} md={5} sm={12} xs={12}>
                            <div className={s.getStartedImage}>
                                <img src={getStartedImage} alt="getStarted" className={cs.fullWidth} />
                            </div>
                        </Col>
                        <Col lg={7} md={7} sm={12} xs={12}>
                            <div className={s.getStartedList}>
                                <div className={s.getStartedListItem}>
                                    <div className={s.getStartedListItemNumber}>1</div>
                                    <div className={s.getStartedListItemContent}>
                                        <h3>List Your car</h3>
                                        <p>Sign up, upload your car details, and set your availability and pricing.</p>
                                    </div>
                                </div>
                                <div className={s.getStartedListItem}>
                                    <div className={s.getStartedListItemNumber}>2</div>
                                    <div className={s.getStartedListItemContent}>
                                        <h3>Get Verified & Booked</h3>
                                        <p>Complete the user verification process and receive bookings from renters.</p>
                                    </div>
                                </div>
                                <div className={s.getStartedListItem}>
                                    <div className={s.getStartedListItemNumber}>3</div>
                                    <div className={s.getStartedListItemContent}>
                                        <h3>Earn Income</h3>
                                        <p>Hand over the car, manage bookings through the app, and earn extra income seamlessly</p>
                                    </div>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </div>
            </div>
        );
    }
}

export default withStyles(s, cs)(GetStarted); 